<template>
  <div class="wg-row" style="height:100%;position:relative;">
    <template v-if="headerItems.length > 0">
      <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
        <div v-for="(hi,index) in headerItems" 
            :key="'hi-'+index" 
            :class="['wg-col', hi.class]"
            :style="{cursor: !hi.disabled ? 'pointer' : 'auto'}"
            @click="!hi.disabled ? sortBy(hi.field) : ''">
          <div class="wg-row" :style="{flexWrap:'nowrap', alignItems: 'center', ...hi.style}">
            <img
              v-if="hi.field === field"
              :src="$anm22.icons.getWorldIcon(direction === 'ASC' ? 'arrowUp' : 'arrowDown')"
              class="com-anm22-app-img-fixed-height-s list-header-arrow"
            >
            <div class="list-header-element">{{ hi.label }}</div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <div class="com-anm22-app-horizontal-line-light"></div>
    </template>
    <div ref="list-div" class="wg-row com-anm22-app-scrolling-panel" :style="contentDivStyle">
      <div v-if="loading" class="wg-row" style="justify-content:center;margin-top:20px;">
        <vue-simple-spinner
          size="medium"
          :line-fg-color="$store.getters['config/HBTheme']['appNameColor']"
        />
      </div>
      <div
        v-else-if="toDisplay.length === 0"
        class="wg-row com-anm22-app-text-l"
        style="padding:10px;justify-content:center;"
      >{{ $anm22.strLang(lang, 'No results found', 'Nessun risultato trovato') }}</div>
      <template
        v-else
        v-for="(i,index) in toDisplay"
      >
        <div 
            v-if="i['list-metadata'].type !== 'separator'"
            :key="'list-item-' + i[keyField]"
            class="wg-row"
            :style="{cursor: (clickFn ? 'pointer' : '')}"
            @click="clickFn ? clickFn(i) : () => {}"
        >
          <slot :element="i" :data="i['list-metadata']"></slot>
        </div>
        <div 
          v-else
          :key="'sep-'+index"
          class="wg-row sep com-anm22-app-text-xl"
        >
          {{ i.text }}
        </div>
      </template>
    </div>
    <div v-if="pagination" class="wg-row pagination-row">
      <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
        <div
          class="com-anm22-app-text-m"
        >{{ $anm22.strLang(lang, 'Results per page', 'Risultati per pagina') }}</div>
        <input
          type="number"
          v-model.lazy.number="limit"
          style="margin-left:10px;width:50px;height:30px;background-color:#fff;"
        >
      </div>
      <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
        <img
          :src="$anm22.icons.getWorldIcon('arrowLeft')"
          class="com-anm22-app-img-fixed-height-m"
          :style="{marginRight:'10px', cursor: currentPage === 1 ? 'default' : 'pointer', opacity: currentPage <= 1 ? 0.3 : 1}"
          @click="previous"
        >
        <div class="com-anm22-app-text-m">{{ currentPage + ' / ' + pages }}</div>
        <img
          :src="$anm22.icons.getWorldIcon('arrowRight')"
          class="com-anm22-app-img-fixed-height-m"
          :style="{marginLeft:'10px', cursor: currentPage === pages ? 'default' : 'pointer', opacity: currentPage === pages ? 0.3 : 1}"
          @click="next"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Boolean,
      default: false
    },
    sorting: {
      type: Boolean,
      default: true
    },
    fieldInit: {
      type: String,
      default: ""
    },
    directionInit: {
      type: String,
      default: "DESC"
    },
    keyField: {
      type: String,
      required: true
    },
    clickFn: {
      type: Function,
      default: null
    },
    // Generatore di funzione di sorting
    sortingFunctionGenerator: {
      type: Function,
      default: null
    },
    listStyle: {
      type: Object,
      default: () => ({})
    },
    // columns info objects {label,column,direction,disabled}
    headerItems: {
      type: Array,
      default: () => []
    },
    // items to display (1 per row)
    itemsToDisplay: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      field: this.fieldInit,
      direction: this.directionInit,
      limit: 40,
      currentPage: 0,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    items() {
      if(this.sorting) {
        const sorted = this.itemsToDisplay.sort(
          this.sortingFunctionGenerator
            ? this.sortingFunctionGenerator(this.field, this.direction)
            : this.defaultSortFn);
        return sorted;
      } else {
        return this.itemsToDisplay;
      }
    },
    pages() {
      const pages = Math.ceil(this.itemsToDisplay.length / this.limit);
      this.currentPage = pages > 0 ? 1 : 0;
      return pages;
    },
    toDisplay() {
      if (this.pagination) {
        const offset = (this.currentPage - 1) * this.limit;
        return this.items.slice(offset, offset + this.limit);
      } else {
        return this.items;
      }
    },
    contentDivStyle() {
      let heightOffset = 0;
      if(this.headerItems.length > 0) {
        heightOffset += 40;
      }
      if(this.pagination) {
        heightOffset += 25;
      }
      return {
        height: 'calc(100% - '+ heightOffset +'px)',
        ...this.listStyle
      }
    }
  },
  methods: {
    defaultSortFn(a,b) {
      const aProp = a[this.field];
      const bProp = b[this.field];
      if (this.direction === "ASC") {
        if (aProp > bProp) {
          return 1;
        }
        if (aProp < bProp) {
          return -1;
        }
        return 0;
      } else {
        if (aProp > bProp) {
          return -1;
        }
        if (aProp < bProp) {
          return 1;
        }
        return 0;
      }
    },
    sortBy(field) {
      if (this.field === field) {
        this.direction = this.direction === "ASC" ? "DESC" : "ASC";
      } else {
        this.direction = "DESC";
      }
      this.field = field;
      this.$emit('direction-changed',this.direction);
      this.$emit('sorting-field-changed', this.field);
    },
    previous() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.$refs['list-div'].scrollTop = 0;
      }
    },
    next() {
      if (this.currentPage < this.pages) {
        this.currentPage++;
        this.$refs['list-div'].scrollTop = 0;
      }
    }
  },
  watch: {
    limit(newVal, old) {
      if (newVal < 1) {
        this.limit = 1;
      }
    }
  },
  created() {
  },
  components: {
    'vue-simple-spinner': Spinner
  }
};
</script>

<style lang="scss" scoped>
.list-header-element {
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  color: #90A4AE;
  font-weight: bold;
  font-size: 16px;
  @media only screen and (max-width: 767px) {
    font-size: 14px;
  }
}
.list-header-arrow {
  margin-right: 5px;
  opacity: 0.5;
}
.pagination-row {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 40px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}
.sep {
  color: #999;
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
}
</style>
